// src/onus_components/DeleteOnuModal.jsx — dar de baja una ONU
//
// Se borra de la OLT (service-port y ONT) y de la base (la fila de `onus`
// y la serie del cliente). Se sigue pidiendo escribir ELIMINAR: es la
// única operación de la pantalla que no tiene vuelta atrás desde aquí.

import React, { useEffect, useState } from "react";
import { authFetch } from "../utils/authFetch";
import { Iconos } from "../componentes/base";
import ModalPasos, { fichaOnu, leerRespuesta, ubicacionDe } from "../componentes/olt/ModalPasos";

export default function DeleteOnuModal({ open, onu, onClose, onSuccess }) {
  const [texto, setTexto] = useState("");
  const [estado, setEstado] = useState("reposo");
  const [salida, setSalida] = useState([]);
  const [error, setError] = useState("");

  const u = ubicacionDe(onu);
  const confirmado = texto.trim().toUpperCase() === "ELIMINAR";

  useEffect(() => {
    if (!open) return;
    setTexto(""); setEstado("reposo"); setSalida([]); setError("");
  }, [open, onu?.id]);

  async function ejecutar() {
    if (!onu?.id || !confirmado) return;
    setEstado("corriendo"); setSalida([]); setError("");
    try {
      const res = await authFetch(`/api/onus/${onu.id}/delete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      const data = await leerRespuesta(res);
      setSalida(Array.isArray(data?.outputs) ? data.outputs : []);
      if (!res.ok || !data?.ok) throw new Error(data?.mensaje || "No se pudo eliminar la ONU.");
      onSuccess?.(data?.mensaje || "ONU eliminada");
    } catch (e) {
      setError(String(e?.message || e));
    } finally {
      setEstado("fin");
    }
  }

  return (
    <ModalPasos
      abierto={open}
      titulo="Eliminar la ONU"
      icono={Iconos.eliminar}
      ficha={fichaOnu(onu)}
      peligro
      mantener={false}
      aviso="Se borra de la OLT y de la base: el cliente se queda sin servicio y con la serie vacía, listo para registrar otra ONU. No se puede deshacer desde aquí."
      verbo="Eliminar ONU"
      listo={confirmado}
      estado={estado}
      salida={salida}
      error={error}
      mensaje={`ONU eliminada de la OLT y de la base. La ${u.fsp} ont ${u.ont} quedó libre.`}
      fases={[
        { rotulo: "Soltar el servicio", coincide: /^undo service-port/, cmds: ["undo service-port (el de la ONU)"] },
        { rotulo: "Borrar la ONT", coincide: /^(interface gpon|ont delete)/, cmds: [`interface gpon ${u.frameSlot}`, `ont delete ${u.pon} ${u.ont}`] },
        { rotulo: "Salir del puerto", coincide: /^quit$/, cmds: ["quit"] },
        { rotulo: "Limpiar la base", app: true, detalle: "clientes.num_serie → vacío · fila de onus borrada" },
      ]}
      onEjecutar={ejecutar}
      onCerrar={onClose}
    >
      <label className="mp-campo">
        <span>Para confirmar, escribe ELIMINAR</span>
        <input
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          placeholder="ELIMINAR"
          autoComplete="off"
          spellCheck={false}
        />
      </label>
    </ModalPasos>
  );
}
